<template>
    <div class="printer-list">
        <div class="d-flex justify-content-between align-items-center mb-3">
            <div class="title">
                <h1 class="mb-0">List of Printers</h1>
            </div>
            <div class="d-flex align-items-center">
                <div class="dropdown">
                    <b-dropdown
                        variant="secondary"
                        :text="statusFilter.label"
                        class="printer-status-dropdown"
                    >
                        <template #button-content>
                            Status: {{ statusFilter.label }}
                        </template>
                        <b-dropdown-item
                            v-for="option in printerStatusOptions"
                            :key="option.value"
                        >
                            {{ option.label }}
                        </b-dropdown-item>
                    </b-dropdown>
                </div>
            </div>
        </div>

        <div class="card card-attribute rounded-lg">
            <div class="card-body overflow-auto p-0">
                <div class="table-holder table-responsive">
                    <table class="table list">
                        <thead>
                            <tr>
                                <th class="width-20">Name:</th>
                                <th class="width-20">Description:</th>
                                <th class="width-20">Status:</th>
                                <th class="width-20">Default:</th>
                                <th class="width-10"></th>
                            </tr>
                        </thead>
                        <tbody>
                            <template v-if="isLoading">
                                <tr>
                                    <td colspan="100">
                                        <LoaderList class="w-100" />
                                    </td>
                                </tr>
                            </template>
                            <template v-else>
                                <template v-if="hasLabelPrinterManager">
                                    <tr
                                        v-for="printer in filteredPrinters"
                                        :key="printer.id"
                                    >
                                        <td>{{ printer.name }}</td>
                                        <td>{{ printer.description }}</td>
                                        <td>
                                            <i
                                                class="fas fa-circle icon-status"
                                                :class="
                                                    printer.status === 'ONLINE'
                                                        ? 'online'
                                                        : 'offline'
                                                "
                                            ></i>
                                            {{
                                                printer.status === "ONLINE"
                                                    ? "Online"
                                                    : "Idle"
                                            }}
                                        </td>
                                        <td>
                                            {{
                                                printer.is_default
                                                    ? "Yes"
                                                    : "No"
                                            }}
                                        </td>
                                        <td class="text-right">
                                            <span
                                                class="cursor-pointer"
                                                @click="onEditPrinter"
                                            >
                                                Edit
                                            </span>
                                            <span> | </span>

                                            <span
                                                class="cursor-pointer"
                                                @click="onDeletePrinter"
                                            >
                                                Delete
                                            </span>
                                        </td>
                                    </tr>
                                </template>
                                <template v-else>
                                    <tr>
                                        <td colspan="5" class="font-italic">
                                            No connected printers detected.
                                            Please use
                                            <span
                                                class="font-weight-bold text-danger"
                                                >Label Printer Manager</span
                                            >
                                            to connect your printers.
                                        </td>
                                    </tr>
                                </template>
                            </template>
                        </tbody>
                        <tbody></tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import PrintersListService from "@/services/setting/printers-list.js";

const PRINTER_ONLINE = {
    value: "ONLINE",
    label: "Online"
};
const PRINTER_IDLE = {
    value: "IDLE",
    label: "Idle"
};
const PRINTER_ALL_STATUS = {
    value: "ALL",
    label: "All"
};

export default {
    components: {
        LoaderList: () => import("@/components/elements/loader-list.vue")
    },
    data() {
        return {
            isLoading: false,
            printers: [],
            printerStatusOptions: [
                PRINTER_ALL_STATUS,
                PRINTER_ONLINE,
                PRINTER_IDLE
            ],
            statusFilter: PRINTER_ALL_STATUS
        };
    },
    computed: {
        filteredPrinters() {
            return this.printers;
        },
        hasLabelPrinterManager() {
            // check if there is any printer with is_google === 0 (Label Printer Manager)
            return this.filteredPrinters.some(p => p.is_google === 0);
        }
    },
    mounted() {
        this.fetchPrinters();
    },
    methods: {
        async fetchPrinters() {
            this.isLoading = true;
            try {
                const printers = await PrintersListService.getPrintersList();

                this.printers = printers.map(p => ({
                    id: p.id,
                    name: p.printer_name,
                    description: p.description || "",
                    status: p.status,
                    is_default: p.is_default,
                    is_google: p.is_google // is_google: 0 means the printer is Label Printer Manager
                }));
            } catch (error) {
                this._message(error.message);
            } finally {
                this.isLoading = false;
            }
        },
        setStatusFilter(option) {
            this.statusFilter = option;
        },
        onEditPrinter() {
            alert("On Sprint 53: VET-11438 [Printer] Edit printer");
        },
        onDeletePrinter() {
            alert("On Sprint 53: VET-11439 [Printer] Delete printer");
        }
    }
};
</script>
<style lang="scss" scoped>
.card-attribute {
    padding: 1rem;
}

.width-20 {
    width: 20%;
}

.width-10 {
    width: 10%;
}

.width-5 {
    width: 5%;
}
.text-right span {
    font-size: 12px;
}
/deep/ .printer-status-dropdown .dropdown-menu {
    transform: none !important;
    top: 100% !important;
    bottom: auto !important;
    right: 0px !important;
    left: auto !important;
}
.text-danger {
    color: #7a0000 !important;
}
</style>
